


































































import EditionModal from "../core/Modals/EditionModal.vue";
import { AvisDePrelevementApi } from "../api/AvisDePrelevementApi";
import { AvisDePrelevement } from "../models/AvisDePrelevement";
import { UserApi } from "../api/UserApi";
import { User } from "../models/User";
import AvisDePrelevementModalEdit from "./AvisDePrelevementModalPartials/AvisDePrelevementModalEdit.vue";
import AvisDePrelevementModalDisplay from "./AvisDePrelevementModalPartials/AvisDePrelevementModalDisplay.vue";
import AvisDePrelevementModalPdfViewer from "./AvisDePrelevementModalPartials/AvisDePrelevementModalPdfViewer.vue";

export default {
    name: "AvisDePrelevementModal",
    components: {
        EditionModal,
        AvisDePrelevementModalEdit,
        AvisDePrelevementModalDisplay,
        AvisDePrelevementModalPdfViewer,
    },
    props: {
        avisDePrelevementId: Number,
        isNew: Boolean,
        forceEditing: Boolean,
    },
    data() {
        return {
            showModal: false,
            avisDePrelevement: null,
            fetching: true,
            editing: false,
            AvisDePrelevementApi: new AvisDePrelevementApi(),
            UserApi: new UserApi(),
            editable: true,
            showPdfInEditMode: false,
        };
    },
    created() {
        var self = this;

        self.UserApi.getCurrentUser().then(function (user) {
            self.editable = !user.hasRole(User.ERole.Syndic);
        });
    },
    watch: {
        avisDePrelevementId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal);
            if (self.showModal) {
                self.fetching = true;
                self.AvisDePrelevementApi.get(self.avisDePrelevementId, {
                    include: "files,client",
                }).then(function (res) {
                    self.avisDePrelevement = res;
                    self.fetching = false;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.avisDePrelevement = new AvisDePrelevement({});
                    this.creationModal();
                }
            },
        },
        forceEditing: function (newVal) {
            this.editing = newVal;
        },
    },
    methods: {
        closeModal: function (data): void {
            this.editing = false;
            this.showModal = false;
            this.$emit("close-modal", data);
        },
        saveAvisDePrelevement: function (): Promise<AvisDePrelevement> {
            var self = this;
            return self.AvisDePrelevementApi.save(self.avisDePrelevement).then(
                function (res) {
                    self.$emit("data-saved", self.avisDePrelevement);
                    return res;
                }
            );
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
        togglePdfVisibility: function (): void {
            this.showPdfInEditMode = !this.showPdfInEditMode;
        },
    },
};
